import React, { useState, useEffect } from "react";
import { Callout, Tag, Divider, ControlGroup, Alert, Dialog, Classes } from "@blueprintjs/core";
import { Trans } from 'react-i18next';
import i18n from '../../i18n';


import { authenticatedDeleteFetch } from "../../utils/AuthenticatedFetch";
import CustomEndpoint from "./CustomEndpoint";
import { EquipmentStandAlone } from "../Supervision/EquipmentStandAlone";
import { asteriskconnection, ua } from "./ClientPhonie";
import { getSetting } from "../Settings/InstallationSettings";




export default function Endpoint(props) {
  var intent = "";
  var icon = "";
  var text = "";
  const [removealert, setremovealert] = useState(false);
  const [EquipmentInfo, setEquipmentInfo] = useState(false);
  const [Callable, setCallable] = useState(false);
  const [AsteriskConnection, setAsteriskConnection] = useState(asteriskconnection);


  ua?.on('registered', () => { 
    setAsteriskConnection(true);
  });
  ua?.on('unregistered', () => { 
    setAsteriskConnection(false);
  });

  useEffect(() => {
    setCallable(["NOT_INUSE", "Not in use", "Ringing", "RINGING"].includes(props.state));
  }, [props.state])

  switch (props.state) {
    case "Not in use":
    case "NOT_INUSE": // waiting for call
      icon = "tick";
      intent = "success";
      text = "not in use";
      break;

    case "Unavailable": // not connected
    case "UNAVAILABLE":
      icon = "offline";
      intent = "danger";
      text = "unavailable";
      break;

    case "Ringing":
    case "RINGING":
      icon = "notifications";
      intent = "success";
      text = "ringing";
      break;

    case "INUSE": // in call
    case "RINGINUSE": // ringing and in use at the same times
    case "In use":
      icon = "phone";
      intent = "primary";
      text = "in use";
      break;

    case "ONHOLD":
    case "On hold":
      icon = "pause";
      intent = "warning";
      text = "on hold";
      break;

    default:
      console.warn("Unhandled endpoint state: ", props.state);
      intent = "normal";
      text = "unknown";
      break;
  }

  if (props.name === "webrtc_client")
    icon = "headset";

  let title = props.equipment_name;

  return <Callout intent={intent} icon={icon} title={<Tag intent={intent} large={true} interactive={true} onClick={() => setEquipmentInfo(true)}>{title}</Tag>}>
    <Dialog
      canEscapeKeyClose={true}
      canOutsideClickClose={true}
      isOpen={EquipmentInfo}
      onClose={() => setEquipmentInfo(false)}>
      <div className={Classes.DIALOG_BODY}>
        <EquipmentStandAlone device={props.equipment.id} server={props.equipment.server} extended={true} />
      </div>
    </Dialog>
    <div className="flexbox-center-large">
      <div>
        {props.in_call_with === undefined && <p><Trans>call_status_{text}</Trans></p>}
        {(props.in_call_with !== undefined && text === "on hold") && <p><Tag intent="warning" >{title}</Tag> <Trans>on hold</Trans></p>}
        {(props.in_call_with !== undefined && text === "in use") && <p><Trans>in call with</Trans> <Tag intent="primary" >{title}</Tag></p>}
      </div>
      <div>
        <ControlGroup>
          {(Callable && AsteriskConnection) &&
            <Tag
              large={true}
              round={true}
              intent="success"
              icon="phone"
              interactive={true}
              onClick={() => {
                // authenticatedPostFetch("/phonie/call", { from: "webrtc_client", to: props.name });
                if (ua)
                  ua.call("sip:" + props.name + "@" + getSetting("phonie server IP", ""), {
                    "mediaConstraints": { audio: true, video: false }
                  });
                else
                  console.error("can't init call, ua not created")
              }}
            />
          }
          {(localStorage.getItem("perm_superadmin") === "true" && Callable && AsteriskConnection) && <Divider />}
          {(localStorage.getItem("perm_superadmin") === "true" && props.ip) &&
            <Tag
              large={true}
              round={true}
              icon="settings"
              interactive={true}
              onClick={() => { window.open("http://" + props.ip, '_blank') }}
            />}
          {localStorage.getItem("perm_superadmin") === "true" &&
            <CustomEndpoint
              onDelete={props.onDelete}
              name={props.name}
              type={props.type}
              equipment_name={props.equipment_name}
              equipment={props.equipment}
            />}
          {localStorage.getItem("perm_superadmin") === "true" &&
            <div><Tag
              large={true}
              round={true}
              icon="trash"
              interactive={true}
              onClick={() => { setremovealert(true) }} />
              <Alert
                confirmButtonText={<Trans>remove this terminal</Trans>}
                cancelButtonText={i18n.t("cancel")}
                isOpen={removealert}
                onClose={() => setremovealert(false)}
                onCancel={() => setremovealert(false)}
                onConfirm={() => authenticatedDeleteFetch("/phonie/endpoint", { remove_name: props.name }, () => {
                  props.onDelete();
                })}
                canEscapeKeyCancel={true}
                canOutsideClickCancel={true}
                intent="danger"
                icon="trash"
              >
                <Trans>are you sure you want to delete the terminal</Trans> <b>{title}</b>
              </Alert>
            </div>}
        </ControlGroup>
      </div>
    </div>
  </Callout >
}
